export default [
    {
        "name": "F&B Revenue 餐饮收入",
        "sort": 0,
        "actual": 0,
        "forecast": 0,
        "budget": 0,
        "last": 0,
        "actVsFcst": 0,
        "actVsBgt": 0,
        "actVsLy": 0,
        "ytdActual": 0,
        "ytdBudget": 0,
        "ytdLast": 0,
        "ytdActVsBgt": 0,
        "ytdActVsLy": 0,
        "threeActual": 0,
        "threeBudget": 0,
        "threeLast": 0,
        "threeActVsLy": 0,
        "threeActVsBgt": 0,
        "wholeActual": 0,
        "wholeBudget": 0,
        "wholeLast": 0,
        "wholeActVsLy": 0,
        "wholeActVsBgt": 0,
        "name_code": "F&B Revenue 餐饮收入"
    },
    {
        "name": "F&B Dep't Profit 餐饮部门利润",
        "sort": 1,
        "actual": 0,
        "forecast": 0,
        "budget": 0,
        "last": 0,
        "actVsFcst": 0,
        "actVsBgt": 0,
        "actVsLy": 0,
        "ytdActual": 0,
        "ytdBudget": 0,
        "ytdLast": 0,
        "ytdActVsBgt": 0,
        "ytdActVsLy": 0,
        "threeActual": 0,
        "threeBudget": 0,
        "threeLast": 0,
        "threeActVsLy": 0,
        "threeActVsBgt": 0,
        "wholeActual": 0,
        "wholeBudget": 0,
        "wholeLast": 0,
        "wholeActVsLy": 0,
        "wholeActVsBgt": 0,
        "name_code": "F&B Dep't Profit 餐饮部门利润"
    },
    {
        "name": "F&B Dep't Profit % 餐饮部门利润率",
        "sort": 2,
        "actual": 0,
        "forecast": 0,
        "budget": 0,
        "last": 0,
        "actVsFcst": 0,
        "actVsBgt": 0,
        "actVsLy": 0,
        "ytdActual": 0,
        "ytdBudget": 0,
        "ytdLast": 0,
        "ytdActVsBgt": 0,
        "ytdActVsLy": 0,
        "threeActual": 0,
        "threeBudget": 0,
        "threeLast": 0,
        "threeActVsLy": 0,
        "threeActVsBgt": 0,
        "wholeActual": 0,
        "wholeBudget": 0,
        "wholeLast": 0,
        "wholeActVsLy": 0,
        "wholeActVsBgt": 0,
        "name_code": "F&B Dep't Profit % 餐饮部门利润率"
    },
    {
        "name": "F&B Beverage Cost 饮品成本",
        "sort": 3,
        "actual": 0,
        "forecast": 0,
        "budget": 0,
        "last": 0,
        "actVsFcst": 0,
        "actVsBgt": 0,
        "actVsLy": 0,
        "ytdActual": 0,
        "ytdBudget": 0,
        "ytdLast": 0,
        "ytdActVsBgt": 0,
        "ytdActVsLy": 0,
        "threeActual": 0,
        "threeBudget": 0,
        "threeLast": 0,
        "threeActVsLy": 0,
        "threeActVsBgt": 0,
        "wholeActual": 0,
        "wholeBudget": 0,
        "wholeLast": 0,
        "wholeActVsLy": 0,
        "wholeActVsBgt": 0,
        "name_code": "F&B Beverage Cost 饮品成本"
    },
    {
        "name": "F&B Beverage Cost % 饮品成本率",
        "sort": 4,
        "actual": 0,
        "forecast": 0,
        "budget": 0,
        "last": 0,
        "actVsFcst": 0,
        "actVsBgt": 0,
        "actVsLy": 0,
        "ytdActual": 0,
        "ytdBudget": 0,
        "ytdLast": 0,
        "ytdActVsBgt": 0,
        "ytdActVsLy": 0,
        "threeActual": 0,
        "threeBudget": 0,
        "threeLast": 0,
        "threeActVsLy": 0,
        "threeActVsBgt": 0,
        "wholeActual": 0,
        "wholeBudget": 0,
        "wholeLast": 0,
        "wholeActVsLy": 0,
        "wholeActVsBgt": 0,
        "name_code": "F&B Beverage Cost % 饮品成本率"
    },
    {
        "name": "F&B Food Cost 食品成本",
        "sort": 5,
        "actual": 0,
        "forecast": 0,
        "budget": 0,
        "last": 0,
        "actVsFcst": 0,
        "actVsBgt": 0,
        "actVsLy": 0,
        "ytdActual": 0,
        "ytdBudget": 0,
        "ytdLast": 0,
        "ytdActVsBgt": 0,
        "ytdActVsLy": 0,
        "threeActual": 0,
        "threeBudget": 0,
        "threeLast": 0,
        "threeActVsLy": 0,
        "threeActVsBgt": 0,
        "wholeActual": 0,
        "wholeBudget": 0,
        "wholeLast": 0,
        "wholeActVsLy": 0,
        "wholeActVsBgt": 0,
        "name_code": "F&B Food Cost 食品成本"
    },
    {
        "name": "F&B Food Cost % 食品成本率",
        "sort": 6,
        "actual": 0,
        "forecast": 0,
        "budget": 0,
        "last": 0,
        "actVsFcst": 0,
        "actVsBgt": 0,
        "actVsLy": 0,
        "ytdActual": 0,
        "ytdBudget": 0,
        "ytdLast": 0,
        "ytdActVsBgt": 0,
        "ytdActVsLy": 0,
        "threeActual": 0,
        "threeBudget": 0,
        "threeLast": 0,
        "threeActVsLy": 0,
        "threeActVsBgt": 0,
        "wholeActual": 0,
        "wholeBudget": 0,
        "wholeLast": 0,
        "wholeActVsLy": 0,
        "wholeActVsBgt": 0,
        "name_code": "F&B Food Cost % 食品成本率"
    },
    {
        "name": "F&B Staff 餐饮部员工总数",
        "sort": 7,
        "actual": 0,
        "forecast": 0,
        "budget": 0,
        "last": 0,
        "actVsFcst": 0,
        "actVsBgt": 0,
        "actVsLy": 0,
        "ytdActual": 0,
        "ytdBudget": 0,
        "ytdLast": 0,
        "ytdActVsBgt": 0,
        "ytdActVsLy": 0,
        "threeActual": 0,
        "threeBudget": 0,
        "threeLast": 0,
        "threeActVsLy": 0,
        "threeActVsBgt": 0,
        "wholeActual": 0,
        "wholeBudget": 0,
        "wholeLast": 0,
        "wholeActVsLy": 0,
        "wholeActVsBgt": 0,
        "name_code": "F&B Staff 餐饮部员工总数"
    },
    {
        "name": "F&B Labor Outsourcing Staff 餐饮部外包员工总数",
        "sort": 8,
        "actual": 0,
        "forecast": 0,
        "budget": 0,
        "last": 0,
        "actVsFcst": 0,
        "actVsBgt": 0,
        "actVsLy": 0,
        "ytdActual": 0,
        "ytdBudget": 0,
        "ytdLast": 0,
        "ytdActVsBgt": 0,
        "ytdActVsLy": 0,
        "threeActual": 0,
        "threeBudget": 0,
        "threeLast": 0,
        "threeActVsLy": 0,
        "threeActVsBgt": 0,
        "wholeActual": 0,
        "wholeBudget": 0,
        "wholeLast": 0,
        "wholeActVsLy": 0,
        "wholeActVsBgt": 0,
        "name_code": "F&B Labor Outsourcing Staff 餐饮部外包员工总数"
    },
    {
        "name": "F&B total staff 餐饮部员工总数",
        "sort": 9,
        "actual": 0,
        "forecast": 0,
        "budget": 0,
        "last": 0,
        "actVsFcst": 0,
        "actVsBgt": 0,
        "actVsLy": 0,
        "ytdActual": 0,
        "ytdBudget": 0,
        "ytdLast": 0,
        "ytdActVsBgt": 0,
        "ytdActVsLy": 0,
        "threeActual": 0,
        "threeBudget": 0,
        "threeLast": 0,
        "threeActVsLy": 0,
        "threeActVsBgt": 0,
        "wholeActual": 0,
        "wholeBudget": 0,
        "wholeLast": 0,
        "wholeActVsLy": 0,
        "wholeActVsBgt": 0,
        "name_code": "F&B total staff 餐饮部员工总数"
    },
    {
        "name": "F&B Total Payroll and Expenses 餐饮部门薪酬及相关福利合计",
        "sort": 10,
        "actual": 0,
        "forecast": 0,
        "budget": 0,
        "last": 0,
        "actVsFcst": 0,
        "actVsBgt": 0,
        "actVsLy": 0,
        "ytdActual": 0,
        "ytdBudget": 0,
        "ytdLast": 0,
        "ytdActVsBgt": 0,
        "ytdActVsLy": 0,
        "threeActual": 0,
        "threeBudget": 0,
        "threeLast": 0,
        "threeActVsLy": 0,
        "threeActVsBgt": 0,
        "wholeActual": 0,
        "wholeBudget": 0,
        "wholeLast": 0,
        "wholeActVsLy": 0,
        "wholeActVsBgt": 0,
        "name_code": "F&B Salary 餐饮部门员工工资（仅工资）"
    },
    {
        "name": "F&B Labor Outsourcing Expenses 餐饮部门劳务费用合计",
        "sort": 11,
        "actual": 0,
        "forecast": 0,
        "budget": 0,
        "last": 0,
        "actVsFcst": 0,
        "actVsBgt": 0,
        "actVsLy": 0,
        "ytdActual": 0,
        "ytdBudget": 0,
        "ytdLast": 0,
        "ytdActVsBgt": 0,
        "ytdActVsLy": 0,
        "threeActual": 0,
        "threeBudget": 0,
        "threeLast": 0,
        "threeActVsLy": 0,
        "threeActVsBgt": 0,
        "wholeActual": 0,
        "wholeBudget": 0,
        "wholeLast": 0,
        "wholeActVsLy": 0,
        "wholeActVsBgt": 0,
        "name_code": "F&B Labor Outsourcing Expenses 餐饮部门劳务费用合计"
    },
    {
        "name": "F&B Labor Expenses 餐饮部门总人工成本及劳务费用",
        "sort": 12,
        "actual": 0,
        "forecast": 0,
        "budget": 0,
        "last": 0,
        "actVsFcst": 0,
        "actVsBgt": 0,
        "actVsLy": 0,
        "ytdActual": 0,
        "ytdBudget": 0,
        "ytdLast": 0,
        "ytdActVsBgt": 0,
        "ytdActVsLy": 0,
        "threeActual": 0,
        "threeBudget": 0,
        "threeLast": 0,
        "threeActVsLy": 0,
        "threeActVsBgt": 0,
        "wholeActual": 0,
        "wholeBudget": 0,
        "wholeLast": 0,
        "wholeActVsLy": 0,
        "wholeActVsBgt": 0,
        "name_code": "F&B Labor Expenses 餐饮部门人工费用总计"
    },
    {
        "name": "F&B Revenue/ Total Revenue % 餐饮收入占酒店总收入%",
        "sort": 13,
        "actual": 0,
        "forecast": 0,
        "budget": 0,
        "last": 0,
        "actVsFcst": 0,
        "actVsBgt": 0,
        "actVsLy": 0,
        "ytdActual": 0,
        "ytdBudget": 0,
        "ytdLast": 0,
        "ytdActVsBgt": 0,
        "ytdActVsLy": 0,
        "threeActual": 0,
        "threeBudget": 0,
        "threeLast": 0,
        "threeActVsLy": 0,
        "threeActVsBgt": 0,
        "wholeActual": 0,
        "wholeBudget": 0,
        "wholeLast": 0,
        "wholeActVsLy": 0,
        "wholeActVsBgt": 0,
        "name_code": "F&B Revenue/ Total Revenue % 餐饮收入占酒店总收入%"
    },
    {
        "name": "Productivity 劳动生产率 - F&B Revenue / F&B Staff 餐饮部每位员工所创造的收入",
        "sort": 14,
        "actual": 0,
        "forecast": 0,
        "budget": 0,
        "last": 0,
        "actVsFcst": 0,
        "actVsBgt": 0,
        "actVsLy": 0,
        "ytdActual": 0,
        "ytdBudget": 0,
        "ytdLast": 0,
        "ytdActVsBgt": 0,
        "ytdActVsLy": 0,
        "threeActual": 0,
        "threeBudget": 0,
        "threeLast": 0,
        "threeActVsLy": 0,
        "threeActVsBgt": 0,
        "wholeActual": 0,
        "wholeBudget": 0,
        "wholeLast": 0,
        "wholeActVsLy": 0,
        "wholeActVsBgt": 0,
        "name_code": "Productivity 劳动生产率 - F&B Revenue / F&B Staff 餐饮部每位员工所创造的收入"
    },
    {
        "name": "Productivity 劳动生产率 - F&B Revenue / F&B Staff(Full time + Outsources <br/>餐饮部每位员工（正式员工+外包）所创造的收入",
        "sort": 15,
        "actual": 0,
        "forecast": 0,
        "budget": 0,
        "last": 0,
        "actVsFcst": 0,
        "actVsBgt": 0,
        "actVsLy": 0,
        "ytdActual": 0,
        "ytdBudget": 0,
        "ytdLast": 0,
        "ytdActVsBgt": 0,
        "ytdActVsLy": 0,
        "threeActual": 0,
        "threeBudget": 0,
        "threeLast": 0,
        "threeActVsLy": 0,
        "threeActVsBgt": 0,
        "wholeActual": 0,
        "wholeBudget": 0,
        "wholeLast": 0,
        "wholeActVsLy": 0,
        "wholeActVsBgt": 0,
        "name_code": "Productivity 劳动生产率 - F&B Revenue / F&B Staff(Full time + Outsources <br/>餐饮部每位员工（正式员工+外包）所创造的收入"
    },
    {
        "name": "F&B Other rexpense 其它费用",
        "sort": 16,
        "actual": 0,
        "forecast": 0,
        "budget": 0,
        "last": 0,
        "actVsFcst": 0,
        "actVsBgt": 0,
        "actVsLy": 0,
        "ytdActual": 0,
        "ytdBudget": 0,
        "ytdLast": 0,
        "ytdActVsBgt": 0,
        "ytdActVsLy": 0,
        "threeActual": 0,
        "threeBudget": 0,
        "threeLast": 0,
        "threeActVsLy": 0,
        "threeActVsBgt": 0,
        "wholeActual": 0,
        "wholeBudget": 0,
        "wholeLast": 0,
        "wholeActVsLy": 0,
        "wholeActVsBgt": 0,
        "name_code": "F&B Other rexpense 其它费用"
    }
]




// WEBPACK FOOTER //
// ./src/components/table/5.0/5/data.js